import { CITIES_FR } from "../data/cities.fr";

function toRadians(value) {
  return (value * Math.PI) / 180;
}

function getSafeCoordinates(input) {
  if (Array.isArray(input) && input.length === 2) {
    const [lng, lat] = input;
    return Number.isFinite(lng) && Number.isFinite(lat) ? [lng, lat] : null;
  }

  if (
    input &&
    typeof input.lng === "number" &&
    typeof input.lat === "number"
  ) {
    return [input.lng, input.lat];
  }

  return null;
}

function getDistanceKm(fromCoordinates, toCoordinates) {
  const from = getSafeCoordinates(fromCoordinates);
  const to = getSafeCoordinates(toCoordinates);

  if (!from || !to) {
    return Number.POSITIVE_INFINITY;
  }

  const [fromLng, fromLat] = from;
  const [toLng, toLat] = to;
  const earthRadiusKm = 6371;
  const deltaLat = toRadians(toLat - fromLat);
  const deltaLng = toRadians(toLng - fromLng);
  const fromLatRadians = toRadians(fromLat);
  const toLatRadians = toRadians(toLat);

  const haversine =
    Math.sin(deltaLat / 2) * Math.sin(deltaLat / 2) +
    Math.cos(fromLatRadians) *
      Math.cos(toLatRadians) *
      Math.sin(deltaLng / 2) *
      Math.sin(deltaLng / 2);

  const arc = 2 * Math.atan2(Math.sqrt(haversine), Math.sqrt(1 - haversine));
  return earthRadiusKm * arc;
}

export function findNearestFrenchCity(coordinates) {
  const safeCoordinates = getSafeCoordinates(coordinates);

  if (!safeCoordinates) {
    return null;
  }

  return CITIES_FR.reduce((closestCity, city) => {
    const cityDistance = getDistanceKm(safeCoordinates, [city.lng, city.lat]);

    if (!closestCity || cityDistance < closestCity.distanceKm) {
      return {
        ...city,
        distanceKm: cityDistance,
      };
    }

    return closestCity;
  }, null);
}

export function resolveFrenchCityLabelFromCoordinates(
  coordinates,
  fallbackLabel = ""
) {
  const nearestCity = findNearestFrenchCity(coordinates);

  if (nearestCity?.name) {
    return nearestCity.name;
  }

  return String(fallbackLabel || "").trim();
}
